import React from 'react'

const SvgThoughtOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M7.348 12.625a.988.988 0 101.398-1.398.988.988 0 00-1.398 1.398zM11.301 12.625a.988.988 0 101.398-1.398.988.988 0 00-1.398 1.398zM15.254 12.625a.988.988 0 101.398-1.398.988.988 0 00-1.398 1.398z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.047 12.914a.988.988 0 110-1.977.988.988 0 010 1.977zm3.953 0a.988.988 0 110-1.976.988.988 0 010 1.976zm3.953 0a.988.988 0 110-1.976.988.988 0 010 1.976z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.8 5.25a2.852 2.852 0 00-2.743 2.072l-.353 1.25-.906-.931A1.95 1.95 0 006.45 8.998l.005.684-.649.092a2.4 2.4 0 00.286 4.775l.478.012.191.438a3.751 3.751 0 005.833 1.388l.522-.434.483.477a2.85 2.85 0 004.83-1.686l.046-.376.329-.187A2.85 2.85 0 0017.4 8.85h-.75v-.751a2.85 2.85 0 00-2.85-2.85zm-3.783.702a4.351 4.351 0 018.078 1.453 4.351 4.351 0 011.764 7.884 4.351 4.351 0 01-6.82 2.628 5.249 5.249 0 01-7.451-1.907 3.9 3.9 0 01-.59-7.587 3.45 3.45 0 015.019-2.471z'
    />
  </svg>
)

export default SvgThoughtOutline
